const isSafari = () => /constructor/i.test(window.HTMLElement);

export const browserFix = () => {
  if (isSafari()) {
    const $primaryLinks = $('a.primary');
    $primaryLinks.addClass('basic-button');
  }
};
